import React from 'react';

import FieldIcon from '@atlaskit/icon/core/field';

import type { StepNode } from '../../../types';

import { FieldOptionsCard } from './FieldOptionsCard';
import { mapFieldOptionsPayload } from './mapFieldOptionsPayload';

export type FieldOptionsBodyProps = {
	steps: StepNode[];
};

export const FieldOptionsBody = ({ steps }: FieldOptionsBodyProps): React.JSX.Element => {
	const cardProps = mapFieldOptionsPayload(steps);
	return (
		<>
			{cardProps.length > 0 && (
				<FieldOptionsCard fieldIcon={<FieldIcon label="" />} {...cardProps[0]} />
			)}
		</>
	);
};
